<template>
<w-frame-popup-content-template v-if="!showAddView" :default-content="false">
  <div style="height:100%;padding:25px;" slot="content">
    <el-row type="flex" class="title-bar" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h4" style="display:inline-block;">공지사항</div>
        <div class="setting-addel mr-l15" style="display:inline-block;">
          <el-button v-show="isAdmin" size="mini" icon="fas fa-plus" @click="showAddNoticeView"></el-button>
          <el-button v-show="isAdmin" size="mini" icon="fas fa-minus" :disabled="selectedNotice.length === 0" @click="deleteNotice"></el-button>
        </div>
      </div>
      <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
    </el-row>
    <el-table-wrapper ref="noticeTable" style="height:calc(100% - 40px);" fit-height :data="noticeDatas" :columns="tableColumn" header-align="center" :row-class-name="checkNotice" :show-search-tool="showSearchTool" :show-custom-header="true" @selection-change="changeHandleSelection"
      :total="total" :column-default="columnDefault" remote pagination @condition-change="onTableConditionChange" @expand-change="expandChange">
      <template #expand-col="props">
        <el-form :model="props.row" label-width="135px">
          <el-form-item label="작성자">{{ props.row.registerName }} ({{ getDate(null, null, props.row.registDatetime) }})</el-form-item>
          <el-form-item label="공지대상">{{ props.row.noticeTargetNames }}</el-form-item>
          <el-form-item label="제목">
            <div v-html="props.row.noticeSubject"/>
          </el-form-item>
          <el-form-item label="내용">
            <div v-html="props.row.noticeContents"/>
          </el-form-item>
          <el-form-item label="첨부파일">
            <span v-for="(file, index) in props.row.fileList" :key="index" style="margin-right: 5px; cursor: pointer;" @click="downloadFile(props.row.seqNumber, file)">
              <i class="far fa-file-download" style="margin-right: 2px;"></i>{{ file.attachFilename }}.{{ file.attachFiletype }}
            </span>
          </el-form-item>
        </el-form>
      </template>
      <template #noticeSubject-col="scope">
        <span class="c-pointer" @click="expandTrigger(scope.row)"><div v-html="scope.row.noticeSubject"/></span>
      </template>
      <template #file-col="scope">
          <i v-if="scope.row.fileList.length > 0" class="far fa-file-download"></i>
        </template>
      <template #edit-col="scope">
        <i class="el-icon-edit c-pointer" @click="showEditNoticeView(scope.row)"></i>
      </template>
    </el-table-wrapper>
  </div>
</w-frame-popup-content-template>
<w-notice-form ref="noticeForm" v-else-if="showAddView" :view-type="viewType" :show-add-view="showAddView" :manager-id="userInfo.managerId" @load-data="loadData" @update-count="getUnreadNoticeCount" @cancel="changeShowAddView" />
</template>

<script>
import isNil from 'lodash/isNil';
import findIndex from 'lodash/findIndex';
import { mapGetters } from 'vuex';
import msgUtil from '@/utils/message';
import { getDateToString } from '@/utils/date';
import userApi from '@/api/frame/user';
import { columnDefault } from '@/constants/table';
import WFramePopupContentTemplate from './FramePopupContentTemplate';
import WNoticeForm from './NoticeForm';

export default {
  name: 'WNoticeTable',
  components: {
    WNoticeForm,
    WFramePopupContentTemplate,
  },
  props: {
    activeTab: {
      type: String,
    },
  },
  data() {
    return {
      columnDefault,
      total: null,
      showAddView: false,
      viewType: 'ADD',
      deleteFlag: false,
      noticeDatas: [],
      selectedNotice: [],
      showSearchTool: false,
      isAdmin: false,
      params: {},
      tableColumn: [],
      etcTableColumn: [
        {
          align: 'center',
          type: 'expand',
          scopedSlot: 'expand-col',
        },
        {
          prop: 'seqNumber',
          label: '번호',
          width: '60px',
        },
        {
          label: '제목',
          sortable: true,
          searchable: true,
          remoteProp: 'notice_subject',
          scopedSlot: 'noticeSubject-col',
        },
        {
          prop: 'registDatetime',
          label: '등록일시',
          width: '150px',
          formatter: this.getDate,
          searchable: true,
          searchType: 'date',
          sortable: true,
          remoteProp: 'en.regist_datetime',
        },
        {
          prop: 'registerName',
          label: '게시자',
          width: '120px',
          searchable: true,
          sortable: true,
          remoteProp: 'rm.manager_name',
        },
        {
          prop: 'fileCount',
          label: '파일',
          width: '60px',
          align: 'center',
          scopedSlot: 'file-col',
        },
      ],
      adminTableColumn: [
        {
          align: 'center',
          type: 'expand',
          scopedSlot: 'expand-col',
        },
        {
          align: 'center',
          type: 'selection',
          width: '50px',
        },
        {
          prop: 'seqNumber',
          label: '번호',
          width: '60px',
        },
        {
          label: '제목',
          searchable: true,
          sortable: true,
          remoteProp: 'notice_subject',
          scopedSlot: 'noticeSubject-col',
        },
        {
          prop: 'registDatetime',
          label: '등록일시',
          width: '150px',
          formatter: this.getDate,
          searchable: true,
          searchType: 'date',
          sortable: true,
          remoteProp: 'en.regist_datetime',
        },
        {
          prop: 'registerName',
          label: '게시자',
          width: '120px',
          searchable: true,
          sortable: true,
          remoteProp: 'rm.manager_name',
        },
        {
          prop: 'fileCount',
          label: '파일',
          width: '60px',
          align: 'center',
          scopedSlot: 'file-col',
        },
        {
          label: '수정',
          width: '60px',
          scopedSlot: 'edit-col',
          align: 'center',
        },
      ],
    };
  },
  computed: mapGetters(['userInfo']),
  watch: {
    activeTab(val) {
      if (val === 'notice') {
        this.loadData();
      }
    },
  },
  mounted() {
    // Admin 일 경우에만 추가/수정/삭제 가능
    this.isAdmin = this.userInfo.managerType === 'ADMIN';
    this.tableColumn = this.isAdmin ? this.adminTableColumn : this.etcTableColumn;
  },
  methods: {
    getDate(row, column, value) {
      return getDateToString(new Date(value));
    },
    loadData() {
      this.$nextTick(() => {
        const tableParams = this.$refs.noticeTable.getParameter();
        userApi.getNoticeList(tableParams).then((response) => {
          if (response.data.success) {
            this.total = response.data.total;
            const noticeData = response.data.data;
            if (!isNil(noticeData)) {
              noticeData.forEach((item) => {
                const noticeContents = item.noticeContents;
                const noticeSubject = item.noticeSubject;
                if (!isNil(noticeContents)) {
                  item.noticeContents = noticeContents.replace(/(?:\r\n|\r|\n|↵)/g, '<br />');
                }
                if (!isNil(noticeSubject)) {
                  item.noticeSubject = noticeSubject.replace(/(?:\r\n|\r|\n|↵)/g, '<br />');
                }
              });
            }
            this.noticeDatas = response.data.data;
          }
        });
      });
    },
    expandTrigger(row) { // 제목 클릭했을 경우에도 expand
      this.$refs.noticeTable.$children[0].toggleRowExpansion(row);
    },
    changeHandleSelection(selectVal) {
      this.selectedNotice = selectVal;
    },
    deleteNotice() {
      const action = msgUtil.action.DELETE;
      const target = '공지사항';
      this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
        userApi
          .deleteNotice(this.selectedNotice)
          .then((response) => {
            if (response.data.success) {
              this.$message(msgUtil.getResultMsgData(action, target, true));
              this.loadData();
              this.getUnreadNoticeCount();
            } else {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            }
          })
          .catch((e) => {
            this.$message(msgUtil.getResultMsgData(action, target, false));
            throw new Error(e);
          });
      });
    },
    downloadFile(seqNumber, file) {
      const params = {
        seqNumber,
        attachFilename: file.attachFilename,
      };
      userApi.downloadNoticeFile(params);
    },
    changeShowAddView() {
      this.showAddView = false;
    },
    /**
     * 읽지않은 공지 클래스 추가
     * @author kimjy
     * @param  {Object} row Row
     * @return {String}     클래스명
     */
    checkNotice({ row }) {
      if (isNil(row.checkDatetime) || row.checkDatetime < 0) {
        return 'table-point';
      }
      return '';
    },
    expandChange(row, expandedRows) {
      // expandedRows에 속해있으면 Open 이라고 판단
      const index = findIndex(expandedRows, ['seqNumber', row.seqNumber]);
      // 해당 row가 Open 되었고, checkDatetime 값이 없을 경우 읽음 표시
      if (index > -1 && (isNil(row.checkDatetime) || row.checkDatetime < 0)) {
        const checkDatetime = new Date().getTime();
        const params = {
          seqNumber: row.seqNumber,
          checkDatetime,
        };
        userApi.readNotice(params).then((response) => {
          if (response.data.success) {
            this.$emit('update-unread-notice-count', response.data.data);
            row.checkDatetime = checkDatetime;
          }
        });
      }
    },
    showAddNoticeView() {
      this.showAddView = true;
      this.viewType = 'ADD';
      this.$nextTick(() => {
        this.$refs.noticeForm.initFormData();
      });
    },
    showEditNoticeView(notice) {
      this.showAddView = true;
      this.viewType = 'UPDATE';
      this.$nextTick(() => {
        this.$refs.noticeForm.initFormData(notice);
      });
    },
    getUnreadNoticeCount() {
      userApi.getUnreadNoticeCount().then((response) => {
        if (response.data.success) {
          this.$emit('update-unread-notice-count', response.data.data);
        }
      });
    },
    onTableConditionChange() {
      this.loadData();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/frame/components/popup/NoticeTable.vue